<template>
  <div>
    <vue-good-table  @on-page-change="onPageChange" @on-sort-change="onSortChange"
		@on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"  
		@on-selected-rows-change="selectionChanged" :totalRows="table.total_records"
      :isLoading.sync="table.isLoading"
		:select-options="{ enabled: true }"
		:pagination-options="{
          enabled: true,
			
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <router-link :to="'/group/edit?id=' + props.row.id">
            <a class="btn btn-primary text-white margin5">Edit</a>
          </router-link>
          <a v-if="props.row.data != 'locked'" v-on:click="deleteContact(props.row.id)" class="btn btn-danger text-white margin5">
            Hapus
          </a>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
	
	<button class="btn btn-success btn-block mt-3" v-on:click="insertIntoGroup()">Tambah</button>
	
  </div>
</template>

<script>
  export default {
   props: ['gid'],
    data() {
      return {
        table: {
          total_records: 100,
          isLoading: true,
          columns: [{
              label: "Nama",
              field: "name",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "50%",
            },
            {
              label: "Nomor Whatsapp",
              field: "number",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "30%",
            },
           
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [{
              field: "",
              type: "",
            }, ],
            page: 1,
            limit: 10,
			group_id: this.gid,
          },
        },
		arrData:[],
	
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      updateParams(newProps) {
        this.table.serverParams = Object.assign({},
          this.table.serverParams,
          newProps
        );
      },
		async insertIntoGroup(){
			
			//let obj = Object.assign({}, this.arrData);
            let payload = {
                contact_id: this.arrData,
                grup_id:  parseInt(this.gid),
			}
			//console.log(payload)
			
            try{
                let response = await this.$store.dispatch('group_update_by_list_contact', payload)
                this.$toast.success(response.data.message);
				this.loadItems();
                //this.searchNonMember()
                //this.$root.$emit("refresh_table", true);
            }catch(err){
                this.$toast.error(err.response.data.message);
            }
      },
		selectionChanged(params){
			
			
			for (let i = 0; i < params.selectedRows.length; i++) {
				let obj = {"contact_id":params.selectedRows[i].id}
				this.arrData[i]= obj ;
			}
			
		},
      onPageChange(params) {
        this.updateParams({
          page: params.currentPage
        });
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({
          limit: params.currentPerPage
        });
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.table.columns[params.columnIndex].field,
          }, ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },
      async loadItems() {
        this.table.isLoading = true
        try {
			await this.getGID()
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records;
          this.table.rows = response.data.data.contacts;
			
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
		this.table.serverParams.group_id = await this.getGID()
		
        return await this.$store.dispatch("group_list_all_not_member", param);
      },
		getGID() {
        return this.$props.gid
      }
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
</style>